import type { ManagerialKpiView } from '../../lib/managerial-kpis'
import { KpiCard } from '../KpiCard'
import styles from './KpiStrip.module.css'

interface KpiStripProps {
  items: ManagerialKpiView[]
}

export function KpiStrip({ items }: KpiStripProps) {
  return (
    <section className={styles.strip} aria-label="Indicadores gerenciais">
      {items.map((item, index) => (
        <KpiCard key={item.id} item={item} index={index} />
      ))}
    </section>
  )
}
